<template>
  <ToggleInput
    class="ui-ToggleControl text-midGrey ml-base"
    :value="value"
    :label="label"
    :labelFirst="true"
    @input="$emit('toggled', !value)"
    data-test="toggler"
  />
</template>

<script>
import { defineComponent } from 'vue';
import ToggleInput from '@/components/tailwind/forms/ToggleInput.vue';
import i18n from '@/locales';

export default defineComponent({
  name: 'ToggleControl',
  components: {
    ToggleInput,
  },
  props: {
    label: {
      type: String,
      required: false,
      default() {
        return i18n.t('ui.common.cardControls.toggle');
      },
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
});
</script>

<style scoped>
/* customise ToggleInput for control */
.ui-ToggleControl :deep(.label) {
  @apply text-midGray text-12 mt-0 mr-base;
}
.ui-ToggleControl :deep(.block) {
  @apply h-5 bg-whiteOverride border-1 border-solid border-border;
  width: 2.5rem;
}
.ui-ToggleControl :deep(.dot) {
  @apply top-0 left-0 bg-whiteOverride border-border;
}
.ui-ToggleControl :deep(input:checked ~ .block) {
  @apply bg-signableGreen;
}
.ui-ToggleControl :deep(input:checked ~ .dot) {
  @apply border-border;
}
</style>
